import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  inline-size: 100%;
`;

export const FieldLabel = styled.p`
  margin: 0;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;

export const PillRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;

  inline-size: 100%;
`;

const Pill = styled.button`
  flex: 1 0 0;

  min-inline-size: 0;
  padding: 12px;

  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-align: start;

  border-radius: 12px;

  cursor: pointer;
`;

export const PillActive = styled(Pill)`
  color: #ffffff;
  font-weight: 700;

  border: 1px solid #dfdfdf;

  background-color: #556bb4;

  &:hover {
    background-color: #556bb4;
  }
`;

export const PillInactive = styled(Pill)`
  color: #2c4692;
  font-weight: 400;

  border: 1px solid #dfdfdf;

  background-color: #ffffff;

  &:hover {
    background-color: #d6dced;
  }
`;
